// DS: IXXX
import React from 'react';
const Padlock = ()=>/*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 62 72",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M48.733 2.147L54.782 8 57 16.03l-4.386 15.833 4.91 1.31L62 42.306l-6.553 24.278L47.322 72l-7.32-1.987-35.97-9.62L0 51.886 6.644 27.01l8.125-5.356 7.299 1.987.01.003 2.117-8.43 2.016-7.265 6.05-5.823L40.485 0l8.247 2.147zm-21.21 22.966l19.603 5.298 3.996-14.46-1.411-5.158-3.892-3.777-3.588-.934-1.745-.467-5.322 1.391-3.912 3.777-1.371 4.969-2.359 9.361zm6.27 23.394l1.592-.606 2.611-3.449-.574-4.323-3.408-2.663-4.284.566-2.652 3.648.585 4.154 1.109 1.341-3.77 7.772 8.206 2.236.584-8.676z",
        fill: "currentColor"
    }));
export default Padlock;

//# sourceMappingURL=Padlock.js.map